import { render } from "./datosPersonales.vue?vue&type=template&id=c442d7d6&scoped=true"
import script from "./datosPersonales.vue?vue&type=script&lang=js"
export * from "./datosPersonales.vue?vue&type=script&lang=js"

import "./datosPersonales.vue?vue&type=style&index=0&id=c442d7d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c442d7d6"

export default script